<div class="p-4 min-w-[700px]">

  <div class="mb-4">

    <h2 class="text-lg font-semibold">
      Tax Breakdown
    </h2>

  </div>

  <div class="overflow-x-auto">

    <table class="w-full border-collapse">

      <thead>

        <tr class="bg-gray-100">

          <th class="p-2 text-left">
            Tax
          </th>

          <th class="p-2 text-right">
            Rate %
          </th>

          <th class="p-2 text-right">
            Taxable
          </th>

          <th class="p-2 text-right">
            Amount
          </th>

        </tr>

      </thead>

      <tbody>

        <tr
          *ngFor="let t of data.taxLines"
          class="border-b">

          <td>
            {{ t.taxName || t.tax_name }}
          </td>

          <td class="text-right">
            {{ t.taxRate || t.rate }}
          </td>

          <td class="text-right">
            {{ t.taxableAmount || t.taxable_amount }}
          </td>

          <td class="text-right">
            {{ t.taxAmount || t.tax_amount }}
          </td>

        </tr>

      </tbody>

      <tfoot>

        <tr class="font-semibold bg-gray-50">

          <td colspan="3"
              class="p-2 text-right">

            Total Tax

          </td>

          <td class="p-2 text-right">

            {{ totalTax }}

          </td>

        </tr>

      </tfoot>

    </table>

  </div>

</div>